import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Logo from "@/components/Logo";
import { useI18n } from "@/i18n";
import { useAuth } from "@/context/AuthContext";
import { fmtErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { t } = useI18n();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const davet = params.get("davet");
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(form.email, form.password);
      navigate(davet ? `/davet/${davet}` : "/app");
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid-bg flex min-h-screen items-center justify-center bg-[#FDFDFD] px-5 py-16">
      <div className="w-full max-w-md">
        <div className="flex justify-center"><Link to="/" data-testid="login-logo-link"><Logo /></Link></div>
        <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
          <h1 className="font-display text-2xl font-medium tracking-tight text-slate-900">{t.auth.loginTitle}</h1>
          <p className="mt-1.5 text-sm text-slate-500">{t.auth.loginSub}</p>
          <form onSubmit={submit} className="mt-7 space-y-5" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="email">{t.auth.email}</Label>
              <Input id="email" type="email" required autoComplete="email" data-testid="login-email-input"
                value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">{t.auth.password}</Label>
              <Input id="password" type="password" required autoComplete="current-password" data-testid="login-password-input"
                value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            </div>
            {error && (
              <p className="rounded-md border border-red-100 bg-red-50 px-3.5 py-2.5 text-sm text-red-600" data-testid="login-error">
                {error}
              </p>
            )}
            <Button type="submit" disabled={busy} data-testid="login-submit-button" className="w-full">
              {busy ? t.auth.working : t.auth.login}
            </Button>
          </form>
          <div className="mt-6 flex items-center justify-between border-t border-slate-100 pt-5">
            <button
              onClick={() => setForm({ email: "demo@iramuhendislik.com", password: "DemoIra2024!" })}
              data-testid="demo-fill-button"
              className="font-mono text-[11px] uppercase tracking-widest text-brand hover:underline">
              {t.auth.demoHint}
            </button>
            <p className="text-xs text-slate-500">
              {t.auth.noAccount}{" "}
              <Link to={davet ? `/kayit?davet=${davet}` : "/kayit"} data-testid="login-to-register-link" className="font-medium text-slate-900 hover:underline">{t.auth.toRegister}</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
